var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',{staticClass:"bg-tes-gray"},[_c('td',{staticClass:"tes-blue",staticStyle:{"text-align":"center !important"},attrs:{"colspan":"20"}},[_vm._t("default",[_vm._v(" موردی یافت نشد... ")])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }